export default "__VITE_ASSET__TTWzMr$h__"